const ratings = [
    "Aerobatic",
    "Examiner",
    "Instructor",
    "Instrument",
    "Night",
    "MEP_Land",
    "MEP_Sea",
    "SEP_Land",
    "SEP_Sea"
].map(i => ({ id: i, label: i.split("_").join(" ") }));

export { ratings };

export const testRatingCategories = [{
    "label": "Category 1",
    "id": "Category1"
}, {
    "label": "Category 2",
    "id": "Category2"
}, {
    "label": "None",
    "id": "None"
}];

export const authorities = [{
    "id": "EUMemberState",
    "label": "Competent Authority (EU Member State)"
}, {
    "id": "NonEUMemberState",
    "label": "National Aviation Authority (Non EU Member State)"
}, {
    "id": "FAAUS",
    "label": "FAA - United States"
}, {
    "id": "Other",
    "label": "Other"
}];


export const licences = [{
    "id": "LandAeroplaneATPL, LandAeroplaneMPL, LandAeroplaneCPL, LandAeroplanePPL",
    "label": "Land",
    "children": [{
        "id": "LandAeroplaneATPL",
        "label": "ATPL (A)"
    }, {
        "id": "LandAeroplaneMPL",
        "label": "MPL (A)"
    }, {
        "id": "LandAeroplaneCPL",
        "label": "CPL (A)"
    }, {
        "id": "LandAeroplanePPL",
        "label": "PPL (A)"
    }],
},
{
    "label": "Sea Aeroplanes",
    "id": "SeaAeroplaneATPL, SeaAeroplaneCPL, SeaAeroplanePPL",
    "children": [{
        "id": "SeaAeroplaneATPL",
        "label": "ATPL (S)"
    }, {
        "id": "SeaAeroplaneCPL",
        "label": "MPL (S)"
    }, {
        "id": "SeaAeroplanePPL",
        "label": "CPL (S)"
    }]
}, {
    "label": "Helicopters",
    "id": "HelicopterATPL, HelicopterCPL, HelicopterPPL",
    "children": [{
        "id": "HelicopterATPL",
        "label": "ATPL (H)"
    }, {
        "id": "HelicopterCPL",
        "label": "MPL (H)"
    }, {
        "id": "HelicopterPPL",
        "label": "CPL (H)"
    }]
}];
